export default __webpack_public_path__ + "assets/images/pre-approved-imagef99fd492eef3ad0ede7db2c8e6f8f770.png";